var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#424242",
    fillOpacity: 0.9,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.0769L14.3333 17.7698L14.3333 22.1227L11 24.1538L11 25L15.1667 25L17.6667 25L21 25L21 24.1538L17.6667 22.1227L17.6667 17.7698L26 20.0769L26 18.3846L17.6667 12.2302L17.6667 6.69231C17.6667 5.75731 16.9208 5 16 5C15.0792 5 14.3333 5.75731 14.3333 6.69231L14.3333 12.2302L6 18.3846L6 20.0769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneCircle);
export default __webpack_public_path__ + "static/media/plane-circle.8d82b4f05df5dda12be9fd2b4920e185.svg";
export { ForwardRef as ReactComponent };